import './toast.css'

let toastContainer = null

function getToastContainer() {
  if (!toastContainer) {
    toastContainer = document.createElement('div')
    toastContainer.id = 'toast-container'
    document.body.appendChild(toastContainer)
  }
  return toastContainer
}

export function showToast(message, type = 'info', duration = 4000) {
  const container = getToastContainer()
  
  const toast = document.createElement('div')
  toast.className = `toast toast-${type}`
  
  const icon = getIcon(type)
  
  toast.innerHTML = `
    <span class="toast-icon">${icon}</span>
    <span class="toast-message">${message}</span>
    <button class="toast-close" aria-label="Close">&times;</button>
  `
  
  container.appendChild(toast)
  
  // Trigger animation
  setTimeout(() => toast.classList.add('toast-show'), 10)
  
  // Close button handler
  const closeBtn = toast.querySelector('.toast-close')
  closeBtn.addEventListener('click', () => {
    dismissToast(toast)
  })
  
  // Auto-dismiss after duration
  if (duration > 0) {
    setTimeout(() => {
      dismissToast(toast)
    }, duration)
  }
  
  return toast
}

function dismissToast(toast) {
  toast.classList.remove('toast-show')
  toast.classList.add('toast-hide')
  
  setTimeout(() => {
    if (toast.parentNode) {
      toast.parentNode.removeChild(toast)
    }
  }, 300)
}

function getIcon(type) {
  const icons = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ'
  }
  return icons[type] || icons.info
}

// Convenience methods
export function showSuccess(message, duration = 4000) {
  return showToast(message, 'success', duration)
}

export function showError(message, duration = 6000) {
  return showToast(message, 'error', duration)
}

export function showWarning(message, duration = 5000) {
  return showToast(message, 'warning', duration)
}

export function showInfo(message, duration = 4000) {
  return showToast(message, 'info', duration)
}
